"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _Elements = require("./Elements");

var SocialGroup = function SocialGroup(_ref) {
  var showPxSite = _ref.showPxSite,
      visibilityOptions = _ref.visibilityOptions,
      socialMedia = _ref.socialMedia,
      size = _ref.size,
      username = _ref.username,
      spacing = _ref.spacing,
      fontColor = _ref.fontColor;
  return /*#__PURE__*/_react["default"].createElement(_Elements.StyledSocialContainer, {
    flex: true,
    align: "center",
    justify: "center"
  }, visibilityOptions.pxProfile === 'VISIBLE' && username && /*#__PURE__*/_react["default"].createElement(_Elements.StyledIcon500px, {
    mr: spacing,
    pointer: true,
    fontColor: fontColor
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://500px.com/p/".concat(username),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "500px"
  }))), (socialMedia === null || socialMedia === void 0 ? void 0 : socialMedia.instagram) && /*#__PURE__*/_react["default"].createElement(_Elements.StyledIconWrapper, {
    mr: spacing,
    pointer: true,
    fontColor: fontColor
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.instagram.com/".concat(socialMedia.instagram),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "portfolio-instagram",
    size: size
  }))), (socialMedia === null || socialMedia === void 0 ? void 0 : socialMedia.twitter) && /*#__PURE__*/_react["default"].createElement(_Elements.StyledIconWrapper, {
    mr: spacing,
    pointer: true,
    fontColor: fontColor
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://twitter.com/".concat(socialMedia.twitter),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "portfolio-twitter",
    size: size
  }))), socialMedia.facebook && /*#__PURE__*/_react["default"].createElement(_Elements.StyledIconWrapper, {
    pointer: true,
    fontColor: fontColor
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.facebook.com/".concat(socialMedia.facebook),
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "portfolio-facebook",
    size: size
  }))));
};

SocialGroup.defaultProps = {
  socialMedia: {
    instagram: '',
    facebook: '',
    twitter: ''
  },
  visibilityOptions: {
    pxProfile: 'VISIBLE'
  },
  showPxSite: true,
  size: 'sm',
  username: '',
  spacing: 'md',
  fontColor: ''
};
SocialGroup.propTypes = {
  socialMedia: _propTypes["default"].shape({
    instagram: _propTypes["default"].string,
    facebook: _propTypes["default"].string,
    twitter: _propTypes["default"].string
  }),
  visibilityOptions: _propTypes["default"].shape({
    pxProfile: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN'])
  }),
  showPxSite: _propTypes["default"].bool,
  size: _propTypes["default"].string,
  username: _propTypes["default"].string,
  spacing: _propTypes["default"].string,
  fontColor: _propTypes["default"].string
};
var _default = SocialGroup;
exports["default"] = _default;